/* eslint-disable import/no-anonymous-default-export */
import gql from 'graphql-tag'
import { GetServerSidePropsContext } from 'next'
import { getClemanClientByServer } from '..'

export const graphqlUrl = gql`
  query tenant($namespace: String) {
    tenant(namespace: $namespace) {
      id
      authingId
      name
      namespace
      logo
      v2WechatProviderId
      v2WechatConnectionId
      authingIdps {
        id
        name
        type
        tenantId
        connections {
          id
          type
          identifier
          displayName
          enabled
        }
      }
    }
  }
`

export interface TenatIdp {
  id: string
  name: string
  type: string
  tenantId: string
  connections: {
    id: string
    type: string
    identifier: string
    displayName: string
    enabled: boolean
  }[]
}

export interface Tenant {
  id: string
  authingId?: string
  name: string
  namespace: string
  logo: string
  v2WechatProviderId?: string
  v2WechatConnectionId?: string
  authingIdps: TenatIdp[]
}

export const getTenantByServer =  async ({namespace, token, context}: {namespace: string, token?: string, context: GetServerSidePropsContext}) => {
  console.log('print namespace', namespace)
  const client = getClemanClientByServer(token, context)
  return client.apollo.query<{ tenant: Tenant }>({
    query: graphqlUrl,
    variables: {
      namespace
    },
    fetchPolicy: 'no-cache'
  })
}
